import { useEffect, useState } from 'react';
import { ViewType } from "../ChangeEmailAddressTypes";
import { Button, Typography } from 'seagull';
import commonStyles from "../ChangeEmailAddress.module.scss";
import { useOnMount } from "../../../hooks/useOnMount";
import { handleRequest } from "../../../infra/utils";
import { useStoreActions } from "../../../contexts";
import { useForm } from 'react-hook-form';
import { ErrorText } from "../../../constants";
import { useSendOTPCode } from "../../../hooks/useSendOTPCode/useSendOTPCode";
import { ServerError } from "../../../infra/ErrorResponse";
import OTPInputSection from "../OTPInputSection";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EnterOneTimePassword = _ref => {
  let {
    onClose,
    handleSetView
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [isLoading, setIsLoading] = useState(false);
  const {
    sendOTPCode
  } = useSendOTPCode();
  const {
    control,
    handleSubmit,
    setError,
    reset,
    watch,
    clearErrors
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: {
      otp: ''
    }
  });
  const handleValidatingError = error => {
    if (error.isTooManyAttemptsError()) {
      handleSetView(ViewType.TooManyAttempts);
      return;
    }
    if (error.hasServerError(ServerError.InvalidOTP)) {
      setError('otp', {
        type: 'manual',
        message: 'Code is invalid. Please try again.'
      });
      return;
    }
    setError('otp', {
      type: 'manual',
      message: ErrorText.UnexpectedErrorTryAgain
    });
  };
  const validateExistingOTP = async _ref2 => {
    let {
      otp
    } = _ref2;
    setIsLoading(true);
    const result = await handleRequest(api.user.verifyOTP({
      otp
    }));
    if (result.success) {
      handleSetView(ViewType.SetUpNewEmail);
    } else {
      handleValidatingError(result.error);
      setIsLoading(false);
    }
  };
  const onSendOTPCode = async _ref3 => {
    let {
      showSuccessToast
    } = _ref3;
    await sendOTPCode({
      requestOTP: () => api.user.getOTPCode(),
      onTooManyRequests: () => handleSetView(ViewType.TooManyAttempts),
      showSuccessToast
    });
  };
  useOnMount(() => {
    onSendOTPCode({
      showSuccessToast: false
    });
  });
  const onResendCode = async () => {
    reset();
    await onSendOTPCode({
      showSuccessToast: true
    });
  };
  const otpValue = watch('otp');
  useEffect(() => {
    clearErrors('otp');
  }, [otpValue, clearErrors]);
  return /*#__PURE__*/_jsxs("form", {
    "data-testid": "enter-one-time-password",
    onSubmit: handleSubmit(validateExistingOTP),
    children: [/*#__PURE__*/_jsxs("div", {
      className: commonStyles.content,
      children: [/*#__PURE__*/_jsx(Typography, {
        "data-testid": "one-time-password-message",
        children: "Please enter the one-time code sent to your registered email."
      }), /*#__PURE__*/_jsx(OTPInputSection, {
        isLoading: isLoading,
        control: control,
        resendCode: onResendCode
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: commonStyles.footer,
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        skin: "primaryOutline",
        "data-testid": "close-button",
        children: "Close"
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        "data-testid": "continue-button",
        loading: isLoading,
        children: "Continue"
      })]
    })]
  });
};
export default EnterOneTimePassword;